import Header from './Header';
export default Header;



// WEBPACK FOOTER //
// ./src/components/App/Header/index.js